module.exports = __webpack_public_path__ + "static/media/color_lines.da6fca93.jpg";